<div id="heat-accumulation">
  @if ((plantationService.loading$ | async) !== true && !loading) {
    <p>{{ 'doktar_app.services.crop_monitoring.heat_accumulation_description' | translate }}</p>

    @if ((plantationService.selectedPlantation$ | async)?.hasRotation) {
      @if (this.data?.length > 0) {
        <div class="diagram-tabs">
          <span class="tab" [class.active]="activeTab === 'standard'" (click)="onTabClick('standard')">
            {{ 'doktar_app.common.standard' | translate }}
          </span>
          <span class="tab" [class.active]="activeTab === 'code-specific'" (click)="onTabClick('code-specific')">
            {{ 'doktar_app.services.crop_monitoring.crop_specific' | translate }}
          </span>
        </div>
        <div echarts [options]="chartOption" class="chart" style="height: 150px"></div>
        <div class="d-flex gap-1 justify-content-end align-items-center">
          <span class="title">{{ 'doktar_app.services.agroclimate.labels_gdd' | translate }}</span>
          <span class="date">({{ lastValue?.date | luxonFormat:'d MMMM y': ('UTC'+ plantationService.selectedPlantation?.offSet) }})</span>
          <span class="value">{{ lastValue?.value }}°</span>
        </div>
      } @else {
        <app-no-analysis [selectedDay]="selectedDay" />
      }
    } @else {
      <div class="no-rotation">
        <i class="ph ph-arrows-counter-clockwise icon"></i>
        <p class="title">{{ 'doktar_app.crop_monitoring.no_rotation_title' | translate }}</p>
        <p class="content">
          {{ 'doktar_app.crop_monitoring.no_rotation_description' | translate }}
        </p>
        <dk-button
          [label]="'doktar_app.crop_monitoring.add_rotation' | translate"
          [routerLink]="
            '/lands/' + plantationService.selectedLand.id + '/' + plantationService.selectedPlantation.id
          " />
      </div>
    }
  } @else {
    <p-skeleton width="25rem" height="2rem" styleClass="mb-3" />
    <div class="d-flex gap-3">
      <p-skeleton width="10rem" height="2rem" styleClass="mb-3" />
      <p-skeleton width="10rem" height="2rem" styleClass="mb-3" />
    </div>
    <p-skeleton styleClass="mb-3" height="7rem" />
  }
</div>
